import Hero from "../../../components/Hero"
import Model from "../../../components/Model"
import Cards from "../../../components/Cards"
import Brands from "../../../components/Brands"
const Home = () => {
  return (
    <div>
      <Hero />
      <Cards />
      <Brands />
      <Model />
    </div>
  )
}

export default Home
